export default __webpack_public_path__ + "static/media/Fire.31cb74fe.svg";